import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { Notification } from 'element-ui'

// import creativeStudioEditor from '@shared/src/store/creativeStudioEditor'

Vue.use(Vuex)

// Load store modules dynamically.
const requireContext = require.context('@/store/modules/', false, /.*\.js$/)

const modules = requireContext
  .keys()
  .map((file) => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true
    }

    return { ...modules, [name]: module }
  }, {})

export default new Vuex.Store({
  state: {
    cancelTokens: [],
    is_init: false,
    is_serve_mode: false,
    is_dev: !Boolean(process.env.VUE_APP_LIVE).valueOf(),
  },

  getters: {
    is_init: (state) => state.is_init,
    is_serve_mode: (state) => state.is_init,
    is_dev: (state) => state.is_dev,
    cancelTokens: (state) => state.cancelTokens,
  },

  mutations: {
    INIT: (state) => {
      state.is_init = true
    },
    IS_SERVE_MODE: (state) => {
      state.is_serve_mode = true
    },
    CLEAR_CANCEL_TOKENS: (state) => {
      state.cancelTokens = []
    },
    ADD_CANCEL_TOKEN: (state, token) => {
      state.cancelTokens.push(token)
    },
  },

  actions: {
    // init store
    async INIT_STORE({ dispatch, commit, rootGetters }) {
      let initData = false

      // get state hydration data from inline script or via API call
      if (window.pl_user_data) {
        initData = window.pl_user_data
      } else {
        try {
          const { data } = await axios.get('/api/auth/refresh')
          if (data.user_data) {
            initData = data.user_data
          }
        } catch (e) {
          console.warn(e.message)
        }

        commit('IS_SERVE_MODE')
      }

      // init whitelabel data if available (must run before pl_message so notifications are branded)
      if (window.pl_whitelabel) {
        commit('whitelabel/INIT', window.pl_whitelabel, { root: true })
      }

      if (window.pl_message) {
        const data = window.pl_message

        if (['success', 'error', 'warning'].includes(data['message-type'])) {
          const brand = rootGetters['whitelabel/name'] || 'Flaminjoy'
          Notification({
            title: brand,
            message: data.message,
            type: data['message-type'],
            duration: 3000,
          })
        }

        window.pl_message = null
      }

      // if user data is available, init state modules
      if (initData) {
        dispatch('INIT_STORE_DATA', initData)
      }

      // mark state as initialized
      commit('INIT')
    },

    // init store data
    INIT_STORE_DATA({ commit }, storeData) {
      if (!storeData || !storeData.settings || !storeData.type) {
        console.warn('INIT_STORE_DATA: Incomplete data, skipping user/limits initialization')
        if (storeData) {
          commit('auth/INIT', storeData, { root: true })
        }
        return
      }
      commit('auth/INIT', storeData, { root: true })
      commit('user/INIT', storeData, { root: true })
      commit('limits/INIT', storeData, { root: true })
    },

    // clean/remove store data
    RESET_STORE_DATA({ commit }) {
      commit('auth/RESET', { root: true })
      commit('user/RESET', { root: true })
      commit('limits/RESET', { root: true })
      commit('ig_analytics/RESET', { root: true })
      // commit('creativeStudio/RESET', { root: true })
    },

    CANCEL_PENDING_REQUESTS(commit) {
      // Cancel all request where a token exists
      commit.state.cancelTokens.forEach((request) => {
        if (request.cancel) {
          request.cancel('cancel request')
        }
      })

      // Reset the cancelTokens store
      commit.commit('CLEAR_CANCEL_TOKENS')
    },
  },

  // store modules
  modules: {
    ...modules,

    // creativeStudioEditor,
  },
})
